/*
 * @Author: your name
 * @Date: 2022-02-23 18:27:08
 * @LastEditTime: 2022-04-08 15:18:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ShopTask-goshop\src\i18n\index.js
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import verConfig from "../utils/verConfig";
import en from './en.json'
import bn from "./bn.json"
import es from "./es.json"

Vue.use(VueI18n);

const messages = {
  en: {
    ...en
  },
  bn: {
    ...bn
  },
  es
};

export const lans = [
  { name: "Spanish", value: "es" },
  { name: "English", value: "en" },
]

export function getLanguage() {
  // 从cookis 里面取语言
  const chooseLanguage = Cookies.get("language");
  if (!chooseLanguage) {
    Cookies.set("language", verConfig.lan || "en");
    localStorage.setItem('language', verConfig.lan || "en")
  }
  // if (chooseLanguage) return chooseLanguage;
  // const language = (
  //   navigator.language || navigator.browserLanguage
  // ).toLowerCase();
  // const locales = Object.keys(messages);
  // for (const locale of locales) {
  //   if (language.indexOf(locale) > -1) {
  //     return locale;
  //   }
  // }
  // return verConfig.lan || "en";
  return chooseLanguage || verConfig.lan || "en"
}

export function setLanguage(val) {
  Cookies.set("language", val);
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages,
});

export default i18n;
